export type SupabaseUserOption = {
  id: string;
  email: string;
};

export type ConversionRecord = {
  _id?: string;
  created_at?: string;
  event?: string;
  source?: string;
  user_id?: string;
  session_id?: string;
  anon_id?: string;
  auction_id?: string;
  search_id?: string;
  raport_id?: string;
  subscription_id?: string;
  filter_id?: string;
  position?: number;
  query?: string;
  utm?: Record<string, unknown>;
  referrer?: string;
  props?: Record<string, unknown>;
};

export type ConversionsResponse = {
  data: ConversionRecord[];
  total: number;
};

export type ConversionStatRow = {
  day: string;
  source: string;
  count: number;
};

export type ConversionsStatsResponse = {
  data: ConversionStatRow[];
};

// Contract enums (search_tracking_conversions.plan.md, section "KONTRAKT MIEDZY-REPO").
// Unknown values still ingest with custom/other fallback on the backend.
export const CONVERSION_EVENTS = [
  "auction_click",
  "auction_view",
  "outbound_click",
  "favorite_add",
  "subscription_create",
  "filter_save",
  "filter_share",
  "report_open",
  "checkout_started",
  "signup",
  "login",
  "custom",
] as const;

export const CONVERSION_SOURCES = [
  "search",
  "similar",
  "report_email",
  "report_sms",
  "report_app",
  "notification_inbox",
  "favorites",
  "dashboard",
  "deep_link",
  "direct",
  "other",
] as const;
